// extracted by extract-css-chunks-webpack-plugin
module.exports = {"originalPrice":"originalPrice_J0WzT"};